import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CRow,
    CCardFooter,
    CButton,
    CLink,
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
    CDropdownItem,
    CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { ThePermission } from '../ThePermission';
import Docs from 'src/views/docs/Docs';
import { docActions, noteActions, userActions, customerActions, employeeActions, housingActions, projectActions, vendorActions, tagActions } from 'src/_actions';
import { helps } from 'src/_helpers';

class DocsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page_header: 'Quản Lý Văn Bản',
        }
    }

    componentDidMount() {
        this.getCategories();
        this.getNotes();
        this.getEmployees();
        this.getCustomers();
        this.getHousings();
        this.getVendors();
        this.getProjects();

        this.getTags();

        if (helps.isEmpty(this.props.users)) {
            this.props.getUsers();
        }

        this.props.getAll();
    }

    async getCategories() {
        if (helps.isEmpty(this.props.categories)) return await this.props.getAllCat();
    }

    async getNotes() {
        if (helps.isEmpty(this.props.notes)) return await this.props.getNotes('docs');
    }

    async getEmployees() {
        if (helps.isEmpty(this.props.employees)) return await this.props.getEmployees();
    }

    async getCustomers() {
        if (helps.isEmpty(this.props.customers)) return await this.props.getCustomers('customer');
    }

    async getHousings() {
        if (helps.isEmpty(this.props.housings)) return await this.props.getHousings();
    }

    async getVendors() {
        if (helps.isEmpty(this.props.vendors)) return await this.props.getVendors();
    }

    async getProjects() {
        if (helps.isEmpty(this.props.projects)) return await this.props.getProjects();
    }

    async getTags() {
        await this.props.getTags('docs');
    }

    render() {
        return (
            <ThePermission {... this.props} component="docs" action="view" alertOut={true}>
                <CRow key={helps.convertToSlug(this.state.page_header)}>
                    <CCol xl={12}>
                        <CCard>
                            <CCardHeader>
                                <CRow>
                                    <CCol>
                                        {this.state.page_header}
                                    </CCol>
                                    <CCol className={'text-right'}>
                                        <CDropdown tag={'span'} className='mr-1 ml-1'>
                                            <CTooltip content='Tham khảo'>
                                                <CDropdownToggle caret color="secondary" size='sm'>
                                                    <CIcon color='warning' name="cil-lightbulb" style={{ cursor: 'help', color: 'orange' }} />
                                                    Tham khảo
                                                </CDropdownToggle>
                                            </CTooltip>
                                            <CDropdownMenu className="pt-0" placement="bottom-end">
                                                <CDropdownItem header>
                                                    <CLink href='https://datafiles.chinhphu.vn/cpp/files/vbpq/2020/03/30.signed.pdf' target='_blank' className={'h6'} title='Nghị định số 30/2020/NĐ-CP của Chính phủ: Về công tác văn thư'>
                                                        <CIcon name="cil-link" className="mfe-1 mt-0"></CIcon>
                                                        Nghị định 30/2020/NĐ-CP
                                                    </CLink>
                                                </CDropdownItem>
                                                <CDropdownItem header>
                                                    <CLink href='https://thuvienphapluat.vn/chinh-sach-phap-luat-moi/vn/ho-tro-phap-luat/tu-van-phap-luat/30698/cach-ghi-so-hieu-van-ban-hanh-chinh-dung-chuan-phap-luat' target='_blank' className={'h6'} title='Cách ghi số hiệu văn bản hành chính đúng chuẩn'>
                                                        <CIcon name="cil-link" className="mfe-1 mt-0"></CIcon>
                                                        Cách ghi số hiệu văn bản hành chính
                                                    </CLink>
                                                </CDropdownItem>
                                            </CDropdownMenu>
                                        </CDropdown>
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody className='docs-table'>
                                <Docs {... this.props} />
                            </CCardBody >
                            <CCardFooter>
                                Tổng: <b>{this.props.docs && <>{this.props.docs.length}</>}</b>
                            </CCardFooter>
                        </CCard >
                    </CCol >
                </CRow >
            </ThePermission>

        );
    }
}

function mapStateToProps(state) {
    const { loading, docs, categories } = state.docsReducer;
    const { users } = state.userReducer;
    const { user } = state.authentication;
    const { notes } = state.noteReducer;
    const { files } = state.fileReducer;
    const { employees } = state.employeeReducer;
    const { customers } = state.customerReducer;
    const { housings } = state.housingReducer;
    const { vendors } = state.vendorReducer;
    const { projects } = state.projectReducer;
    const { tags } = state.tagReducer;
    return { loading, docs, categories, users, user, tags, notes, employees, files, customers, housings, vendors, projects };
}

const actionCreators = {
    getAll: docActions.getAll,
    updateField: docActions.updateField,
    getAllCat: docActions.getAllCat,
    getUsers: userActions.getAll,
    getNotes: noteActions.getAll,
    getEmployees: employeeActions.getAll,
    getCustomers: customerActions.getAll,
    getHousings: housingActions.getAll,
    getVendors: vendorActions.getAll,
    getProjects: projectActions.getAll,
    getTags: tagActions.getAll,
};

const connectedContainer = connect(mapStateToProps, actionCreators)(DocsContainer);
export { connectedContainer as DocsContainer };